<script>
  import { onMount } from "svelte";
  import { select } from "d3-selection";

  export let dots = 0;
  export let maxDots = 0;
  export let id = 0;
  export let props = {};

  let contentRect;
  let svgObj;
  let svgSize = 0;
  const margin = 1;

  const draw = () => {
    if (dots > 0) {
      svgSize = Math.min(
        Math.floor(contentRect?.width ?? 0),
        Math.floor(contentRect?.height ?? 0),
      );
      const drawSize = svgSize - margin * 2;
      const allCols = Math.ceil(Math.sqrt(maxDots));
      const currentCols = Math.ceil(Math.sqrt(dots));
      const dotSize = Math.floor(drawSize / allCols);
      const dotsObj = Array(dots).fill(1);
      const dotRadius = Math.floor(dotSize / 2) - 1;
      const dotCenter = Math.round(dotSize / 2);

      if (dotRadius > 0) {
        const svg = select(svgObj);
        svg.selectAll("g").remove();
        const g = svg
          .append("g")
          .attr("transform", `translate(${margin} ${margin})`);

        g.selectAll("circle")
          .data(dotsObj)
          .enter()
          .append("circle")
          .attr("cx", (d, i) => (i % currentCols) * dotSize + dotCenter)
          .attr(
            "cy",
            (d, i) => Math.floor(i / currentCols) * dotSize + dotCenter,
          )
          .attr("r", dotRadius)
          .attr("class", `dot dot-${id}`)
          .style("stroke", props?.stroke ?? "black")
          .attr("stroke-width", props?.strokeWidth ?? 1)
          .style("fill", props?.fill ?? "black")
          .style("opacity", props?.opacity ?? ".85");
      }
    }
  };

  onMount(() => {
    draw();
  });

  $: dots, draw();
  $: maxDots, draw();
  $: contentRect, draw();
</script>

<section class="dots" bind:contentRect>
  <svg
    class="chart=svg-dots"
    width={svgSize}
    height={svgSize}
    viewBox={`0 0 ${svgSize} ${svgSize}`}
    bind:this={svgObj}
  />
</section>

<style>
  .dots {
    display: block;
    height: 50vh;
  }

  svg {
    margin: 0 auto;
  }
</style>
